import { useContext, useEffect, useState } from 'react';
import { NavLink, useNavigate, useSearchParams } from 'react-router-dom';
import { GetCurrentUserDataSession, SignOutSession } from '../repo/SessionsRepo.js';
import { AuthContext } from '../store/auth-context.js';
import { enshortenName } from '../utils/string.js';
import { config } from '../config';

function MainNavigation() {
  const { token, currentUser, logout } = useContext(AuthContext)
  const navigate = useNavigate()
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  // Prefer the user held in the auth context (stored at sign-in). Fall back to
  // a fetch only if we have a token but no stored user yet.
  const [fetchedUser, setFetchedUser] = useState(null);
  const currentUserData = currentUser || fetchedUser;
  const [dropdownTrigger, setDropdownTrigger] = useState(null);
  const [dropdownOptions, setDropdownOptions] = useState(null);
  const [showDropdown, setShowDropdown] = useState(0);

  const [searchParams] = useSearchParams();
  const inviteToken = searchParams.get('token') || ''
  const inviteGroupID = searchParams.get('group_id') || ''


  const handleToggleMobileMenu = () => {
    setShowMobileMenu((prev) => !prev);
  };

  const buildUrlWithInvite = (url) => {
    if (inviteToken !== '') {
      url = url + '?token=' + inviteToken + '&group_id=' + inviteGroupID
    }

    return url
  }

  const signOutHandler = async () => {
    setShowMobileMenu(false)
    setShowDropdown(0)

    try {
      await SignOutSession()
    } catch (error) {
      console.error('Error signing out:', error)
    }

    // Clear the auth context (token + user) and its localStorage mirror, then
    // return home. Done here in the component so context state stays in sync,
    // which a router action could not do.
    logout()
    navigate('/')
  }

  const userUpdateHandler = () => {
    window.location.href = "/user/update"
  }

  const updatePasswordHandler = () => {
    window.location.href = "/user/update_password"
  }

  const otherHandler = () => {
    window.location.href = "/user/other"
  }

  useEffect(() => {
    const fetchCurrentUserData = async () => {
      if (!token || currentUser) return;

      try {
        const userData = (await GetCurrentUserDataSession()).data;
        setFetchedUser(userData);
      } catch (error) {
        console.error('Error fetching current user data:', error);
      }
    };
    fetchCurrentUserData();
  }, [token, currentUser]);

  useEffect(() => {
    if (currentUserData) {
      setDropdownTrigger(document.getElementById('dropdownDefaultButton'));
      setDropdownOptions(document.getElementById('dropdown'));
    };
  }, [currentUserData]);

  useEffect(() => {
    if (dropdownTrigger) {
      dropdownTrigger.addEventListener('mouseenter', () => {
        setShowDropdown((previous) =>  (previous + 1));
      });
      dropdownTrigger.addEventListener('mouseleave', () => {
        setShowDropdown((previous) =>  (previous - 1) < 0 ? 0 : previous - 1);
      });
    };
  }, [dropdownTrigger]);

  useEffect(() => {
    if (dropdownOptions) {
      dropdownOptions.addEventListener('mouseenter', () => {
        setShowDropdown((previous) => previous + 1);
      });
      dropdownOptions.addEventListener('mouseleave', () => {
        setShowDropdown((previous) => (previous - 1) < 0 ? 0 : previous - 1);
      });
    };
  }, [dropdownOptions]);

  useEffect(() => {
    if (showDropdown === 0) {
      try {
        dropdownOptions.classList.add('hidden');
        dropdownTrigger.classList.add('border-transparent');
      } catch (error) {
      }
    }
  }, [showDropdown, dropdownOptions, dropdownTrigger]);

  const userProfileDropdownHandler = () => {
    const dropdownButtonRect = dropdownTrigger.getBoundingClientRect();

    dropdownOptions.style.top = dropdownButtonRect.bottom + 'px';
    dropdownOptions.style.left = dropdownButtonRect.left + 'px';
    dropdownOptions.style.width = dropdownButtonRect.width + 'px';

    if (dropdownOptions.classList.contains('hidden')) {
      dropdownTrigger.classList.remove('border-transparent');
      dropdownOptions.classList.remove('hidden');
    } else {
      dropdownOptions.classList.add('hidden');
      dropdownTrigger.classList.add('border-transparent');
      setShowDropdown((previous) => (previous - 1) < 0 ? 0 : previous - 1);
    }
  }

  return (
      <nav>
        <div className="relative container mx-auto p-6 flex items-center justify-between lg:w-6xl">
          <div className="flex items-center space-x-20">
            <a href={token ? "/" : config.pagesUrl}>
              <img className="hidden lg:block" src="/images/logo-small.png" alt="Bolão da Copa"/>
              <img className="block lg:hidden" src="/images/logo-tiny.png" alt="Bolão da Copa"/>
            </a>
          </div>

          <div className="hidden items-center space-x-6 font-bold text-slate-600 lg:flex pr-12">
            {!token && (
              <>
                <NavLink to={buildUrlWithInvite('/sign_in')} className="hover:text-black">
                  Entrar
                </NavLink>
                <NavLink to={buildUrlWithInvite('/sign_up')} className="px-8 py-3 font-bold text-white bg-green-600 rounded-full hover:bg-green-700">
                  Cadastrar
                </NavLink>
            </>
            )}
            {token && (
              <>
                <div id="dropdownDefaultButton" data-dropdown-toggle="dropdown" onClick={userProfileDropdownHandler} className="hover:cursor-pointer inline-flex items-center justify-center text-block bg-brand box-border border border-transparent hover:bg-brand-strong shadow-xs font-medium leading-5 rounded-base text-sm px-4 py-2.5 min-w-32" type="button">
                  <span id="currentUserName">{currentUserData?.data?.name ? enshortenName(currentUserData.data.name) : "Carregando..."}</span>
                  <svg className="w-4 h-4 ms-1.5 -me-0.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 9-7 7-7-7"/></svg>
                </div>

                <NavLink to="/groups/new" className="px-8 py-3 font-bold text-white bg-green-600 rounded-full hover:bg-green-700">
                  Criar Bolão
                </NavLink>
              </>
            )}
          </div>

          <button
            id="menu-btn"
            className="block hamburger lg:hidden focus:outline-none"
            type="button"
            onClick={handleToggleMobileMenu}
          >
            <span className="hamburger-top"></span>
            <span className="hamburger-middle"></span>
            <span className="hamburger-bottom"></span>
          </button>

        </div>

        <div id="dropdown" className="absolute z-10 hidden bg-neutral-primary-medium border border-default-medium rounded-base shadow-lg w-44">
          <ul className="text-sm text-body font-medium" aria-labelledby="dropdownDefaultButton">
            <li className="hover:bg-green-200 hover:cursor-pointer p-2" onClick={userUpdateHandler}>
              Alterar nome
            </li>
            <li className="hover:bg-green-200 hover:cursor-pointer p-2" onClick={updatePasswordHandler}>
              Alterar senha
            </li>
            <li className="hover:bg-green-200 hover:cursor-pointer p-2" onClick={otherHandler}>
              Outros
            </li>
            <li className="hover:bg-green-200 hover:cursor-pointer p-2" onClick={signOutHandler}>
              Sair
            </li>
          </ul>
        </div>

        {showMobileMenu && (
        <div id="menu" className="absolute p-6 rounded-lg bg-blue-950 left-6 right-6 top-25 z-1000 lg:hidden">
          {!token && (
          <div
            className="flex flex-col items-center justify-center w-full space-y-6 font-bold text-white rounded-sm">
            <NavLink to={buildUrlWithInvite('/sign_in')} onClick={handleToggleMobileMenu} className="w-full pt-6 border-gray-400 text-center hover:cursor-pointer">Entrar</NavLink>
            <NavLink to={buildUrlWithInvite('/sign_up')} onClick={handleToggleMobileMenu} className="w-full py-3 text-center rounded-full bg-green-600">Cadastrar</NavLink>
          </div>
          )}
          {token && (
          <div
            className="flex flex-col items-center justify-center w-full space-y-6 font-bold text-white rounded-sm">
            <NavLink to="/groups/new" onClick={handleToggleMobileMenu} className="w-full py-3 text-center rounded-full bg-green-600">Criar Bolão</NavLink>
            <span to="#" onClick={userUpdateHandler} className="w-full pt-6 border-gray-400 text-center hover:cursor-pointer">Alterar nome</span>
            <span to="#" onClick={updatePasswordHandler} className="w-full pt-6 border-gray-400 text-center hover:cursor-pointer">Alterar senha</span>
            <span to="#" onClick={signOutHandler} className="w-full pt-6 border-gray-400 text-center hover:cursor-pointer">Sair</span>
          </div>
          )}
        </div>)}        
      </nav>
  );
}

export default MainNavigation;
